import { useQueryClient } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { JobNote } from "@/types";

/**
 * This hook is used to add a new job note to the job notes query
 * without refetching the entire query.
 */
export const useAddJobNote = () => {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();
  const queryClient = useQueryClient();

  return ({ jobNoteToAdd }: { jobNoteToAdd: JobNote }) => {
    queryClient.setQueryData(
      ["job-notes", currentCompanyId, currentJobId],
      (cachedData: JobNote[]) => {
        // Important to add the new job note to the top of the list.
        return [jobNoteToAdd, ...cachedData];
      },
    );
  };
};
